import DomainGroupLogo from './domain-group-logo';
export default DomainGroupLogo;